import ScratchJr from '../../ScratchJr';

let _overlay = null;

export default class CompletionModal {
    static show ({title, message, onReplay, onNext}) {
        CompletionModal.dismiss();

        _overlay = document.createElement('div');
        _overlay.className = 'activity-completion-overlay';

        const modal = document.createElement('div');
        modal.className = 'activity-completion-modal';

        const closeBtn = document.createElement('button');
        closeBtn.className = 'activity-completion-close';
        closeBtn.setAttribute('aria-label', 'Close');
        closeBtn.innerHTML = '&times;';
        closeBtn.addEventListener('pointerup', () => {
            CompletionModal.dismiss();
        });
        modal.appendChild(closeBtn);

        const header = document.createElement('div');
        header.className = 'activity-completion-header';

        const logo = document.createElement('img');
        logo.src = 'assets/lobby/scratchJrlogo.svg';
        logo.alt = 'Bluux';
        logo.className = 'activity-completion-logo';
        header.appendChild(logo);

        const titleEl = document.createElement('h3');
        titleEl.className = 'activity-completion-title';
        titleEl.textContent = 'Activity Complete!';
        header.appendChild(titleEl);

        const subtitle = document.createElement('p');
        subtitle.className = 'activity-completion-subtitle';
        subtitle.textContent = title;
        header.appendChild(subtitle);

        modal.appendChild(header);

        const body = document.createElement('div');
        body.className = 'activity-completion-body';

        const stars = document.createElement('div');
        stars.className = 'activity-completion-stars';
        stars.textContent = '\u2B50\u2B50\u2B50';
        body.appendChild(stars);

        const messageEl = document.createElement('p');
        messageEl.className = 'activity-completion-message';
        messageEl.textContent = message;
        body.appendChild(messageEl);

        const actions = document.createElement('div');
        actions.className = 'activity-completion-actions';

        const replayBtn = document.createElement('button');
        replayBtn.className = 'activity-completion-btn-replay';
        replayBtn.setAttribute('aria-label', 'Replay activity');
        replayBtn.innerHTML = '&#8634; Replay';
        replayBtn.addEventListener('pointerup', () => {
            CompletionModal.dismiss();
            if (onReplay) onReplay();
        });
        actions.appendChild(replayBtn);

        const nextBtn = document.createElement('button');
        nextBtn.className = 'activity-completion-btn-next';
        nextBtn.setAttribute('aria-label', 'Next activity');
        nextBtn.innerHTML = 'Next Activity &#9654;';
        nextBtn.addEventListener('pointerup', () => {
            CompletionModal.dismiss();
            if (onNext) {
                onNext();
            } else {
                ScratchJr.saveProject(null, ScratchJr.flippage);
            }
        });
        actions.appendChild(nextBtn);

        body.appendChild(actions);
        modal.appendChild(body);
        _overlay.appendChild(modal);
        document.body.appendChild(_overlay);

        return _overlay;
    }

    static dismiss () {
        if (_overlay && _overlay.parentNode) {
            _overlay.style.opacity = '0';
            const el = _overlay;
            _overlay = null;
            setTimeout(() => {
                if (el && el.parentNode) {
                    el.parentNode.removeChild(el);
                }
            }, 300);
        } else {
            _overlay = null;
        }
    }
}
